import React, {
  useCallback,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { SlackViewMobileMachinesContainer } from "./SlackViewMobileMachinesContainer";
import { GlobalContext } from "../../../context/GlobalContext";
import { SlackViewUIContext } from "../Context/SlackViewUIContext";
import { SlackLocalStoreManager } from "../Utils/SlackLocalStoreManager";

export const SlackViewMobile = () => {
  const { isSearchOpen, setIsSearchOpen } = useContext(SlackViewUIContext);
  const { log } = useContext(GlobalContext);

  const localStoreManager = useMemo(
    () => SlackLocalStoreManager.getInstance(),
    []
  );

  const [readMachines, setReadMachines] = useState(() =>
    localStoreManager.getMachines()
  );

  useEffect(() => {
    localStoreManager.cleanExpired();

    const intervalId = setInterval(() => {
      localStoreManager.cleanExpired();
      setReadMachines(localStoreManager.getMachines());
    }, 60000);

    return () => clearInterval(intervalId);
  }, [localStoreManager]);

  const setReadMachine = useCallback(
    (id: string, value: boolean, postCount: number) => {
      if (value) {
        localStoreManager.addMachine(id, postCount);
      } else {
        localStoreManager.removeMachine(id);
      }

      setReadMachines(() => localStoreManager.getMachines());
    },
    [localStoreManager]
  );

  const onSearchButtonClick = useCallback(() => {
    setIsSearchOpen(!isSearchOpen);
  }, [isSearchOpen, setIsSearchOpen]);

  const containerStyle = useMemo(
    () => ({
      backgroundColor: "rgb(94, 54, 95)",
      height: "100vh",
      width: log ? "100%" : "initial",
      marginTop: "6vh",
    }),
    [log]
  );

  return (
    <div style={containerStyle}>
      <SlackViewMobileMachinesContainer
        onSearchButtonClick={onSearchButtonClick}
        readMachines={readMachines}
        setReadMachine={setReadMachine}
      />
    </div>
  );
};
